import axios from "axios";

// Fallback to same-origin if REACT_APP_BACKEND_URL is missing or points to an
// unreachable domain. This protects against deployment env var typos.
const ENV_URL = process.env.REACT_APP_BACKEND_URL;
const FALLBACK = typeof window !== "undefined" ? window.location.origin : "";
export const BACKEND_URL = ENV_URL && ENV_URL.startsWith("http") ? ENV_URL : FALLBACK;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "mpsound_token";

export const api = axios.create({
  baseURL: API,
  timeout: 15000, // 15s — prevents requests from hanging forever
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
